import React, { useState } from "react";
import FeedbackStepLayout from "../FeedbackStepLayout";

const Step1Reflection = ({ data, updateData, nextStep }) => {
  const [rating, setRating] = useState(data.selfReflection || 0);

  const handleNext = () => {
    if (rating === 0) return alert("Please rate how you felt about your progress.");
    updateData("selfReflection", rating);
    nextStep();
  };

  const handleSelect = (value) => {
    // tap again to unselect
    setRating((prev) => (prev === value ? 0 : value));
  };

  // Codi-style reflective messages
  const messages = {
    0: "",
    1: "Rough patch, huh? Every checkpoint has those days — that’s how growth starts.",
    2: "Tough one, but you made it through. Let’s look at what slowed you down.",
    3: "Solid effort — not perfect, but you showed up and made progress.",
    4: "You handled it well! Maybe not flawless, but definitely confident work.",
    5: "You crushed it. Sounds like you were fully in your flow this time.",
  };

  return (
    <FeedbackStepLayout
      title="Let’s Touch Base"
      subtitle="How did this checkpoint feel for you overall?"
      step={1}
      totalSteps={5}
      onNext={handleNext}
    >
      {/* === Circle Rating === */}
      <div className="flex justify-between items-center mt-8 mb-4">
        {Array.from({ length: 5 }, (_, i) => i + 1).map((value) => (
          <button
            key={value}
            onClick={() => handleSelect(value)}
            className="focus:outline-none"
          >
            <div
              className={`w-9 h-9 rounded-full transition-all duration-200 ${
                rating >= value
                  ? "bg-gradient-to-b from-blue-500 to-blue-400"
                  : "bg-zinc-300 hover:bg-zinc-400"
              }`}
            />
          </button>
        ))}
      </div>

      {/* === Reflection Text === */}
      <div className="text-center text-sm text-neutral-700 font-medium min-h-[32px] transition-all">
        {messages[rating]}
      </div>
    </FeedbackStepLayout>
  );
};

export default Step1Reflection;
